//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageHeader from "@/0/components/comForm/comPageHeader";
import FormEdit from "@/0/components/comForm/comFormEdit/comFormQueryEdit";
import PageFooter from "@/0/components/comForm/comPageFooter2";

export default {
  props: ["queryCondition"],
  components: {
    "page-header": PageHeader,
    "form-edit": FormEdit,
    "page-footer": PageFooter,
  },
  data() {
    return {
      isShow: false,
      headerConfig: {
        Title: "高级查询"
      },
      footerConfig: {
        ButtonList: [
          {
            Text: "重  置",
            Type: "warning",
            OnClick: () => {
              this._onResetClick();
            }
          },
          {
            Text: "查  询",
            Type: "primary",
            OnClick: () => {
              this._onQueryClick();
            }
          }
        ]
      },      
    };
  },
  created() {

},

  methods: {
    IsShow() {
      this.isShow = !this.isShow;
    },

    Show(){
      this.$show();
    },
    $show(){
      this.isShow = true;
    },

    Hide(){
      this.$hide();
    },

    $hide(){
      this.isShow = false;
    },

    getSubmitData(){
      console.log("getSubmitData====");
      return this.$getSubmitData();
    },

    $getSubmitData(){

      if(!this.$refs.comFormEdit) return null;
      var formData = this.$refs.comFormEdit.$getSubmitData();
      console.log("$this.$refs.comFormEdit====",formData);
      return formData;

    },


    async _onResetClick() {

      this.$refs.comFormEdit.$reset();
      var postData = this.$refs.comFormEdit.$getSubmitData();

      console.log("postData",postData);
    },

    async _onQueryClick() {
      this.$hide();
      this.$parent.$refreshForm();
    }

  }
};
